import { Stack } from "expo-router";

export default function AddResidentsLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
      }}
    />
  );
}
